const Host = "http://city.shiminjia.com"
const Apis = {
  Index: Host + '/api/Sly_Goods/index', // 首页
  Fillter: Host + '/api/sly_goods/category', // 分类
  Detail: Host + '/api/Sly_Goods/dtl', // 商品详情
  Selement: Host + '/api/Sly_Goods/selement', // 确认订单页
  CreateAddress: Host + '/api/Sly_Goods/createAddress', // 添加地址
  Buy: Host + '/api/Sly_Goods/buy', // 提交订单
  MyOrder: Host + '/api/Sly_Goods/myorder', // 我的订单
  Receive: Host + '/api/Sly_Goods/receiv', // 确认收货
  Refund: Host + '/api/Sly_Goods/refund', // 发起售后
  UserAddress: Host + '/api/sly_Goods/useraddress', // 地址列表,
  Pay: Host + '/api/sly_pay/pay', // 支付
  DelAddress: Host + '/api/sly_Goods/delAddress', // 删除地址
  Address: Host + '/api/sly_Goods/editAddress', // 地址详情
  Upload: Host + '/activity/files/uploadOneOSS', //上传图片
  PayRefund: Host + '/api/sly_pay/refund', // 发起退款
  DelOrder: Host + '/api/sly_goods/delorder', // 删除订单
  HotKW: Host + '/api/sly_Goods/hotkw', // 热搜词
}
export default Apis